import { render } from "./edit.vue?vue&type=template&id=63328474"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/feedbackTag/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63328474"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63328474', __exports__)) {
    console.log('reload')
    api.reload('63328474', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=63328474", () => {
    console.log('re-render')
    api.rerender('63328474', render)
  })

}


export default __exports__